import { formatNumber, sign } from '@/utils/number'
import { getIcon } from '@/utils/image'

export const tickerTransformer = (item, context) => {
  const minimumFractionDigits = 3
  const maximumFractionDigits = 3
  const price = formatNumber(item.close, context, { minimumFractionDigits, maximumFractionDigits })
  const change = formatNumber(item.change, context, { minimumFractionDigits, maximumFractionDigits })

  return {
    name: item.ticker,
    price: { text: price },
    change24h: {
      text: change,
      sign: sign(change),
    },
  }
}

export const tableTransformer = (item, context) => {
  const pairCurrencies = item.ticker ? item.ticker.split('/') : ['', '']

  return {
    ask: { text: formatNumber(item.ask, context, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) },
    bid: { text: formatNumber(item.bid, context, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) },
    change24h: {
      text:
        item.change === 0
          ? item.change
          : formatNumber(item.change, context, { minimumFractionDigits: 3, maximumFractionDigits: 3 }),
      sign: sign(formatNumber(item.change, context, { minimumFractionDigits: 3, maximumFractionDigits: 3 })),
    },
    changePercent: {
      text:
        item.changePercent === 0
          ? item.changePercent
          : formatNumber(item.changePercent, context, {
              minimumFractionDigits: 2,
            }),
      sign: sign(
        formatNumber(item.changePercent, context, {
          minimumFractionDigits: 2,
        })
      ),
    },
    high: { text: formatNumber(item.high, context, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) },
    low: { text: formatNumber(item.low, context, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) },
    name: item.ticker,
    pairCurrencies,
    price: { text: formatNumber(item.close, context, { minimumFractionDigits: 3, maximumFractionDigits: 3 }) },
    icons: {
      base: getIcon(pairCurrencies[0]),
      quote: getIcon(pairCurrencies[1]),
    },
  }
}

export const chartTransformer = (item, context) => {
  const minimumFractionDigits = 5
  const maximumFractionDigits = 5
  const price = formatNumber(item.close, context, { minimumFractionDigits, maximumFractionDigits })

  return {
    cols: [
      { header: 'ytd-change', text: item.ytd },
      { header: 'daily-high', text: item.high },
      { header: 'daily-low', text: item.low },
    ],
    name: item.ticker,
    price: { text: formatNumber(price, context, { minimumFractionDigits, maximumFractionDigits }) },
    symbol: { text: item.symbol },
  }
}

export const latestPriceTransformer = (item, context) => {
  return formatNumber(item.close, context, { minimumFractionDigits: 5, maximumFractionDigits: 5 })
}
